

import DM1 from "./assets/images/DM1.png"
import DM2 from "./assets/images/DM2.png"
import DM3 from "./assets/images/DM3.png"
import DM4 from "./assets/images/DM4.png"
import DM5 from "./assets/images/DM5.png"
import DM6 from "./assets/images/DM6.png"
import DM7 from "./assets/images/DM7.png"
export const DM = [
    {
        id: 1,
        src:DM1 ,
    },
    {
        id: 2,
        src: DM2,
    },
    {
        id: 3,
        src: DM3,
    } ,
    {
        id: 4,
        src:DM4 ,
    },
    {
        id: 5,
        src: DM5,
    },
    {
        id: 6,
        src: DM6,
    },
    {
        id: 7,
        src:DM7 ,
    }
]